import { jsx as _jsx } from "react/jsx-runtime";
import { DecorativeElementV2 } from '@kubit/web-ui-components/decorativeElementV2';
import { DecorativeElementTypeV2, } from '@kubit/web-ui-components/decorativeElementV2/types';
export const BadgeLogoDecorativeElement = ({ decorativeElement, sizeStyles, }) => {
    if (!decorativeElement) {
        return null;
    }
    if (decorativeElement.elementType === DecorativeElementTypeV2.ICON) {
        return (_jsx(DecorativeElementV2, { customIconStyles: sizeStyles?.decorativeElement?.ICON, ...decorativeElement }));
    }
    if (decorativeElement.elementType === DecorativeElementTypeV2.ILLUSTRATION) {
        return (_jsx(DecorativeElementV2, { customIllustrationStyles: sizeStyles?.decorativeElement?.ILLUSTRATION, ...decorativeElement }));
    }
    return _jsx(DecorativeElementV2, { ...decorativeElement });
};
//# sourceMappingURL=badgeLogoDecorativeElement.js.map